
//------------------------------------------------------------------------------

//
if (document.querySelector('form.training-booking-form') === null) {
    return;
}

//
const createElement  = require('../utils/createElement.js');
const renderTemplate = require('../utils/renderTemplate.js');
const oneWayBinding  = require('../utils/oneWayBinding.js');
const getResponse    = require('../utils/getResponse.js');
const debounce       = require('../utils/debounce.js');

//------------------------------------------------------------------------------

//
const additionalDelegatesContainer = document.querySelector('.additional-delegates');

//define a object to store our process, this will make use of a one way binding to update the dom as the values are changed
let coursePricing = {};

//setup one-way binding so we can update the prices on the page
Object.defineProperty(coursePricing, 'memberBookingFee', oneWayBinding('memberBookingFee', 'span[data-binding="member-booking-fee"]'));
Object.defineProperty(coursePricing, 'nonMemberBookingFee', oneWayBinding('nonMemberBookingFee', 'span[data-binding="non-member-booking-fee"]'));

//set the default baseline prices up
const pricingSource = document.querySelector('.training-booking-form');

coursePricing.memberBookingFee    = pricingSource.dataset.memberBookingFee;
coursePricing.nonMemberBookingFee = pricingSource.dataset.nonMemberBookingFee;

//if the "same day event" bundle is selected - update the prices
const sameDayBundleInput = document.querySelector('input[name="includeBundleDeal"]');
if (typeof sameDayBundleInput !== 'undefined' && sameDayBundleInput !== null) {
    sameDayBundleInput.addEventListener('change', (event) => {
        const pricingSource = document.querySelector(((event.target.checked === true) ? '.training-event-bundle' : '.training-booking-form'));
        coursePricing.memberBookingFee    = pricingSource.dataset.memberBookingFee;
        coursePricing.nonMemberBookingFee = pricingSource.dataset.nonMemberBookingFee;
    });
}

//toggle the display of the "additional questions" when selecting a member/associate while logged in
var selectedDelegateButtons = document.querySelectorAll('.training-delegate input[name="delegates[]"]');
if (typeof selectedDelegateButtons !== 'undefined' && selectedDelegateButtons.length > 0) {
    for (const selectedDelegateButton of selectedDelegateButtons) {
        selectedDelegateButton.addEventListener('change', (event) => {
            const delegateWrapper = event.target.closest('.training-delegate');
            delegateWrapper.classList.toggle('selected', event.target.checked);
        });
    }
}

//add events the additional delegate form
function applyAdditionalDelegateEvents(additionalDelegateForm) {

    //check the the email address is not in use by an existing member (this is just a note - not a validation file)
    const additionalDelegateEmailInput = additionalDelegateForm.querySelector('input[name^="additionalDelegateEmail"]');
    additionalDelegateEmailInput.addEventListener('change', (event) => {
        getResponse('/training-academy/actions/check-email-address', { 'email' : event.target.value }).then((response) => {
            if (response.status === 'error') {
                const additionalDelegateEmailInputGroup = additionalDelegateEmailInput.closest('.input-group');
                additionalDelegateEmailInputGroup.append(createElement('div', {}, response.message))
            }
        });
    });

    //allow the additional delegate to be removed
    const additionalDelegateRemoveButton = additionalDelegateForm.querySelector('button[data-action="remove-delegate"]');
    if (additionalDelegateRemoveButton !== null) {
        additionalDelegateRemoveButton.addEventListener('click', debounce(200, (event) => {
            additionalDelegateForm.remove();
        }));
    }

}

//
const additionalDelegateForms = additionalDelegatesContainer.querySelectorAll('.training-delegate');
for (const additionalDelegateForm of additionalDelegateForms) {
    applyAdditionalDelegateEvents(additionalDelegateForm);
}

//add a new "delegate" form to enable booking multiple delegates at once
var addAdditionalDelegateButton = document.querySelector('button[data-action="add-additional-delegate"]');
addAdditionalDelegateButton.addEventListener('click', debounce(200, (event) => {

    //get the max "additional delegate index" and add 1
    const additionalDelegatesInputs = additionalDelegatesContainer.querySelectorAll('input[name="additionalDelegates[]"]');
    const delegateCount = ([...additionalDelegatesInputs].reduce((acc, cur) => {
        return Math.max(acc, cur.value);
    }, 0) + 1);

    //
    additionalDelegatesContainer.insertAdjacentHTML('beforeend', renderTemplate('tpl-training-delegate-form', {
        'nonMemberBookingFee': coursePricing.nonMemberBookingFee,
    }));
    const additionalDelegateForm = additionalDelegatesContainer.querySelector('.training-delegate:last-child');

    //set the value of the additionalDelegates input - this will allow us to validate etc
    const additionalDelegatesInput = additionalDelegateForm.querySelector('input[name="additionalDelegates[]"]');
    if (typeof additionalDelegatesInput !== 'undefined') {
        additionalDelegatesInput.value = delegateCount;
    }

    //find all the label/input/select/textarea elements, and mutate the for/name/id attribute to add the new "index"
    const elements = additionalDelegateForm.querySelectorAll('label, input:not([name="additionalDelegates[]"]), select, textarea');
    if (typeof elements !== 'undefined' && elements.length > 0) {
        for (const element of elements) {
            for (const attribute of ['for', 'id', 'name']) {
                if (element.hasAttribute(attribute)) {
                    element.setAttribute(attribute, element.getAttribute(attribute) + String(delegateCount));
                }
            }
        }
    }

    //
    applyAdditionalDelegateEvents(additionalDelegateForm);

}));

//------------------------------------------------------------------------------
